angular.module('counters', [])
    .service('Counters', Counters);

Counters.$inject = ['$rootScope','$stateParams', '$timeout', 'Pay', 'AmountCommission'];

function Counters($rootScope, $stateParams, $timeout, Pay, AmountCommission) {
    var BigNumber = require('bignumber.js');

    var counter = {
        data: {},
        meterUnits: ['GC', 'KW', 'MW', 'GJ'],
        mUnit: 'GC',
        serviceHeat: false,
        KW: 0.0008598,
        MW: 0.8598,
        GJ: 0.239,
        validateMeters: function (meter) {
            var regTariff = /^\d{1,5}((\.|,)\d{1,5})?$/;
            var regMeters = /^\d{0,8}$/;
            var regMetersOldValue = /^\d{0,8}$/;

            if (!Pay.data.twoStepCreateForm.$dirty) {
                return false;
            }

            Pay.data.twoStepCreateForm.$setValidity('previous' + meter.Id, regMetersOldValue.test(meter.previous));

            if (+meter.current < +meter.previous) {
                Pay.data.twoStepCreateForm.$setValidity('current' + meter.Id, false);
            } else {
                Pay.data.twoStepCreateForm.$setValidity('current' + meter.Id, regMeters.test(meter.current));
            }

            if (!meter.difference) {
                Pay.data.twoStepCreateForm.$setValidity('difference', false);
            } else {
                Pay.data.twoStepCreateForm.$setValidity('difference', true);
            }

            if (meter.difference == 0.00) {
                Pay.data.twoStepCreateForm.$setValidity('Tariff' + meter.Id, true);
            } else {
                Pay.data.twoStepCreateForm.$setValidity('Tariff' + meter.Id, regTariff.test(meter.tariff));
            }
        },
        calculateMeters: function (meter, meterUnit, meters) {
            counter.mUnit = meterUnit || counter.meterUnits[0];//todo scope
            
            //TODO not call if subscribe is active
            if ($stateParams.subscribe) {
                return;
            }
            // end validation
            Pay.amount = 0;
            Pay.amountInput = 0;
            Pay.amountMin = 0;
            Pay.amountWithCommission = 0;
            if(meter.previous) { meter.previous = meter.previous; }

            if (+meter.current >= +meter.previous) {
                meter.difference = (meter.current - meter.previous).toFixed(meter.dp_values ? meter.dp_values : 4);
                meter._difference = (meter.current - meter.previous).toFixed(meter.dp_values ? meter.dp_values : 4);

                // meter.difference = new BigNumber(meter.current).minus(meter.previous).toFixed(4);
                // meter._difference = new BigNumber(meter.current).minus(meter.previous).toFixed(4);

                if (meter.calc && meter.amount) {
                    if (angular.isFunction(counter.data.calcTest) && !meter.showCalc) {//todo scope calcTest
                        counter.data.calcTest(meter);//todo scope calcTest
                    }

                    Pay.amount = Pay.amountInput = Pay.amountMin = new BigNumber(meter.amount).toFixed(2);
                    AmountCommission.localCalcCommission();//todo scope
                }

                if (!meter.calc && meter.tariff && meter.difference) {
                    var tariff = parseFloat(meter.tariff.toString().replace(',', '.'));
                    var meterAmount = meter.amount = new BigNumber(meter.difference).times(tariff).toFixed(meter.dp_values ? meter.dp_values : 4);
                    /*recount if chosen meter units for heat meter*/
                    if (counter.serviceHeat && counter.mUnit && counter.mUnit != 'GC') {//todo scopes
                        Pay.amountMin = new BigNumber(counter[counter.mUnit]).times(meterAmount).toFixed(2);//todo scopes
                        counter.data.unitDifference = new BigNumber(counter[counter.mUnit]).times(item.difference).toFixed(meter.dp_values ? meter.dp_values : 4);//todo scopes
                    } else {
                        Pay.amountMin = new BigNumber(Pay.amountMin).plus(meterAmount).toFixed(2);
                    }

                    /*recount if chosen meter units for heat meter*/
                }

                if (Pay.subsidyObj.subsidy) {
                    Pay.amount = Pay.amountInput = Pay.amountMin;
                    if ((Pay.amountMin - Pay.subsidyObj.subsidyNum) < 0 || (Pay.amountMin - Pay.subsidyObj.subsidyNum) < Pay.service.amount_min) {
                        AmountCommission.data.limitSummError = true;//todo scope
                    } else {
                        AmountCommission.data.limitSummError = false;//todo scope
                    }
                    AmountCommission.changingPayAmountWithSubsidy();//todo scope
                } else {
                    if (!meter.showCalc) {
                        Pay.amount = Pay.amountInput = Pay.amountMin;
                    }
                }

                if(meters && meters.length > 1) {
                    var totalAmount = 0;
                    meters.forEach(function (m) {
                        totalAmount = +m.amount + totalAmount;
                    });

                    Pay.amount = Pay.amountInput = Pay.amountMin = totalAmount;
                }

                AmountCommission.localCalcCommission();//todo scope
            } else {
                meter.difference = new BigNumber(0).toFixed(meter.dp_values ? meter.dp_values : 2);
                meter._difference = new BigNumber(0).toFixed(meter.dp_values ? meter.dp_values : 2);
            }
            // validation addon
            counter.validateMeters(meter);
        },
        selectProduct: function (product) { //select meter product(heat or water)

            if (Pay.selectedProduct != product) {
              Pay.data.showBlock = false;

              if (Pay.checkFields.length > 1) {
                  Pay.amount = 0;
                  Pay.amountInput = 0;
              }

              Pay.selectedProduct = product;

              if (product.amountType > 0) {
                  Pay.amountInput = product.amount;
                  Pay.oldAmountInput = Pay.amountInput;
              } else {
                  if ($stateParams.amount) {
                      Pay.amount = Pay.amountInput = $stateParams.amount;
                  } else {
                      Pay.amount = Pay.amountInput = product.amount;
                  }
                //   Pay.amount = Pay.amountInput = $stateParams.amount > 0 ? $stateParams.amount : product.amount;
                  Pay.oldAmountInput = Pay.selectedProduct.amount;
              }

              Pay.selectedProduct.selected = true;
              Pay.checkFields.forEach(function (item) {
                  /*show radiobuttons with meter units if service have a heat meter*/
                  if (Pay.selectedProduct.serviceName === "Отопление" ||
                      Pay.selectedProduct.serviceName === "Опалення" ||
                      Pay.selectedProduct.serviceName === "ЦЕНТРАЛІЗОВАНЕ ОПАЛЕННЯ ЛІЧИЛЬНИК") {
                      counter.serviceHeat = true;
                  } else {
                      counter.serviceHeat = false;
                  }
                  /*END show meter units*/
                  if (product.serviceName !== item.serviceName) {
                      item.selected = false;
                  }
              });
              $rootScope.$broadcast('countAmount');
            } else {
                counter.clearProduct();
            }
        },
        clearProduct: function() {
            Pay.selectedProduct = [];
            Pay.amount = 0;
            Pay.amountInput = 0;
            Pay.amountWithCommission = 0;
        }
    };

    return counter;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/counters/counters.js
 ** module id = 81
 ** module chunks = 1
 **/